import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Person } from '../../models/Person';

@Component
export default class MemberNameComponent extends Vue {
    @Prop() public member: Person = new Person();
}
